<template>
  <div class="go-in">
    <div id="top"></div>
    <banner img="../assets/test/about_us_header.png" title= ""/>
    <div class="section" v-loading="loading">
      <div class="section-content">
        <div class="content-summary">
          <div class="summary-left">
            <p class="title">{{$t("message.homemenu2")}}</p>
            <p class="content">
              {{$t("message.abouttext1")}}
            </p>
          </div>
          <div class="summary-right wow bounce">
            <img src="../assets/test/gzh.png" alt />
          </div>
        </div>
        <el-divider class="el-divider-active">
          <i class="el-icon-arrow-down el-icon-arrow-down-active"></i>
        </el-divider>
        <!-- 团队介绍-->
        <!-- 
        <div class="content-summary2">
          <div class="summary-left2" >
            <div style="margin-top: 2%;">
               <div class="top">
                  <h3>{{$t("message.bitext5")}}</h3>
                  <div class="border"></div> 
            </div>
            </div>
            <div class="teams">
              
              <div class="teams-team">
                <img src="../assets/test/head2.png" alt=""><br>
                <h2>{{$t("message.bitext8")}}</h2>
                <p>{{$t("message.bitext9")}}</p>
              </div>
              
           
              <div class="teams-team">
                <img src="../assets/test/head3.png" alt=""><br>
                <h2>{{$t("message.bitext10")}}</h2>
                <p>{{$t("message.bitext11")}}</p>
              </div>
              <div class="teams-team">
                <img src="../assets/test/head4.png" alt=""><br>
                <h2>{{$t("message.bitext12")}}</h2>
                <p>{{$t("message.bitext13")}}</p>
              </div>
            </div>
            <p style="visibility: hidden;">_</p>
                <el-divider class="el-divider-active">
                <i class="el-icon-arrow-down el-icon-arrow-down-active"></i>
                </el-divider>
            <p style="visibility: hidden;">_</p>
          </div>
        </div>
        -->

        <p style="visibility: hidden;" >_</p>

        <!-- 发展规划 -->
        <div class="fazhan" style="">
            <div class="top" style="margin: 0px auto;">
                <h3>{{$t("message.abouttext16")}}</h3>
                <div class="border"></div> 
            </div>
            <p style="visibility: hidden;" >_</p>
            <p style="visibility: hidden;" >_</p>
            <p style="visibility: hidden;" >_</p>
          <div :class="{'fazhan-left-cn wow bounceInLeft':$i18n.locale==='zh','fazhan-left-en wow bounceInLeft':$i18n.locale==='en'}">
            <h1>{{$t("message.abouttext3")}}</h1>
            <img src="../assets/test/fazhan.png">
            <p>{{$t("message.abouttext4")}}</p>
            <p>{{$t("message.abouttext5")}}</p>
          </div>
          
          <div :class="{'fazhan-right-cn wow bounceInUp':$i18n.locale==='zh','fazhan-right-en wow bounceInUp':$i18n.locale==='en'}">
            <h2>1.{{$t("message.abouttext6")}}</h2>
            <p><i class="el-icon-check" style="font-size: 20px;color:#3c6088;"></i> {{$t("message.abouttext7")}}</p>
            <h2>2.{{$t("message.abouttext8")}}</h2>
            <p><i class="el-icon-check" style="font-size: 20px;color:#3c6088;"></i> {{$t("message.abouttext9")}}</p>
            <h2>3.{{$t("message.abouttext10")}}</h2>
            <p><i class="el-icon-check" style="font-size: 20px;color:#3c6088;"></i> {{$t("message.abouttext11")}}</p>
            <h2>4.{{$t("message.abouttext12")}}</h2>
            <p><i class="el-icon-check" style="font-size: 20px;color:#3c6088;"></i> {{$t("message.abouttext13")}}</p>
            <h2>5.{{$t("message.abouttext14")}}</h2>
            <p><i class="el-icon-check" style="font-size: 20px;color:#3c6088;"></i> {{$t("message.abouttext15")}}</p>
          </div>
          
        </div>
      <div style="margin-top: 3%;visibility: hidden;">s</div>
        <!-- 公司荣誉 -->
        <div class="content-honor">
          <p style="visibility: hidden;;">_</p>
                <el-divider class="el-divider-active">
                <i class="el-icon-arrow-down el-icon-arrow-down-active"></i>
                </el-divider>
        <p style="visibility: hidden;" >_</p>
          <div class="honor-big-img">
            <el-dialog :title="dialogTitle" :visible.sync="dialogTableVisible">
            <img :src="require(`../assets/test/honnor${honorNum}.png`)" alt="Honor Image"/>
            </el-dialog>
          </div>
          
          <div class="top">
            <h3>{{$t("message.abouttext2")}}</h3>
            <div class="border"></div>
          </div>
          <ul class="honor-show" >
            <li v-for="(honor,index) in honorList" :key="index">
              <img :src="require(`../assets/test/honnor${index + 1}.png`)" alt="Honor Image"
              @click="dialogTableVisible = true ;dialogUrl = imgserver + honor.Img;dialogTitle= honor.Remark;honorNum=index+1"
              />
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Banner from "../components/Banner";
import { WOW } from 'wowjs';
export default {
  components: {
    Banner,
  },
  data() {
    return {
      loading: false,
      honorList: [
      {"CreateTime": "2023-11-29T13:34:04.613","Id": 41,"Img": "honnor1.png","Remark": "会员证书"},
      {"CreateTime": "2023-11-29T13:34:04.613","Id": 42,"Img": "honnor1.png","Remark": "会员证书"},
      {"CreateTime": "2023-11-29T13:34:04.613","Id": 42,"Img": "honnor1.png","Remark": "会员证书"},
      {"CreateTime": "2023-11-29T13:34:04.613","Id": 42,"Img": "honnor1.png","Remark": "会员证书"},
      {"CreateTime": "2023-11-29T13:34:04.613","Id": 42,"Img": "../assets/test/honnor2.png","Remark": "会员证书"},
    ],
      partnerImg: [],
      courseList: [],
      teamItem: [],
      swiperOption: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      dialogTableVisible: false,
      dialogUrl: "",
      dialogTitle: "",
      honorNum: 1,
    };
  },
  mounted() {
    //初始化动画
    var wow = new WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 0,
      mobile: true,
      live: true
    })
    wow.init();
  }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
#top{
  margin: 0px;
}

.fazhan{
  width: 1240px;
  height: 600px;
}
.fazhan-left-cn{
  font-family: 'Courier New', Courier, monospace;
  //font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  letter-spacing: 2px;font-size: 18px;
  //border: red solid 1px;
  width: 500px;
  height: 100%;
  float: left;
  margin: 10px 50px;
  padding: 5px;
  border-right: black solid 2px;
  box-shadow: 10px 10px 0px rgba(0, 0, 0, 0.2);
  margin-top: 5px;
  margin-bottom: 5px;
  margin-left: 50px;
  margin-right: 0%;
  p{
    padding: 10px;
    text-align: left;
    //font-weight: bold;
    font-size: 20px;
    text-indent: 10%;
  }
  img{
    padding: 0 10px;
  }
  h1{
    padding: 10px;
    font-size: 30px;
    text-align: right;
  }
  
}
.fazhan-right-cn{
  //font-family: 'Courier New', Courier, monospace;
  font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  //border: red solid 1px;
  width: 600px;
  height: 520px;
  float: right;
  margin-top: 5px;
  margin-bottom: 5px;
  margin-left: 0px;
  margin-right: 5%;
  //border-left: black solid 2px;
  padding-left: 1px;
  border-top: black solid 0px;
  box-shadow: 10px 0px 0px rgba(0, 0, 0, 0.2);
  h2{
    margin: 17px 30px;
    //color: red;
    font-size: 25px;
    color: rgb(16, 84, 110);
  }
  
}
.fazhan-left-en{
  //font-family: 'Courier New', Courier, monospace;
  font-family:'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  letter-spacing: 2px;font-size: 18px;
  //border: red solid 1px;
  width: 500px;
  height: 100%;
  float: left;
  margin: 10px 60px;
  padding: 5px;
  border-right: black solid 2px;
  box-shadow: 10px 10px 1px rgba(0, 0, 0, 0.2);
  margin-top: 5px;
  margin-bottom: 5px;
  margin-left: 50px;
  margin-right: 0%;
  p{
    padding: 10px;
    text-align: left;
    //font-weight: bold;
    font-size: 15px;
  }
  img{
    padding: 0 10px;
  }
  h1{
    padding: 10px;
    font-size: 40px;
    text-align: right;
    color: rgb(16, 84, 110);
  }
  
}
.fazhan-right-en{
  //font-family: 'Courier New', Courier, monospace;
  font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
  //border: red solid 1px;
  
  width: 600px;
  height: 520px;
  float: right;
  margin-top: 5px;
  margin-bottom: 5px;
  margin-left: 0px;
  margin-right: 5%;
  //border-left: black solid 2px;
  padding-left: 1px;
  border-top: black solid 3px;
  //box-shadow: 10px 0px 0px rgba(0, 0, 0, 0.2);
  h2{
    margin: 5px 15px;
    //color: red;
    font-size: 25px;
    color: skyblue;
  }
  
}
.teams{
  display: flex;
  float: left;
}

.teams-team{
    //border: rgb(52, 6, 221) solid 1px;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 395px;
    height: 300px;
    margin: 100px 10px;
   padding: 10px;
   p{
    margin: 5% 20%;
   }
   img{
    text-align: center;
    margin: 0 auto;
   }
}

.go-in {
  width: 100%;
  height: 100%;
  //background: linear-gradient( rgb(36, 143, 243), rgb(221, 166, 95));
  //background-color: #14679f;
  position: relative;
  overflow: hidden;
  .section {
    width: 100%;
    &-content {
      width: 1240px;
      margin: 0 auto;
      background-color: #fff;
      //border: red solid 1px;
      .content-summary {
        //height: 300px;
        //border: red solid 1px;
        display: flex;
        justify-content: space-around;
        padding: 100px 0;
        .summary-left {
          //border: red solid 1px;
          width: 600px;
          .title {
            margin-bottom: 20px;
            font-size: 25px;
            color: #e13834;
          }
          .eTitle {
            font-size: 17px;
            color: #e13834;
            padding: 20px 0;
          }
          .content {
            color: #14679f;
            font-size: 16px;
            text-indent: 25px;
            line-height: 30px;
            //border: red solid 1px;
          }
          
        }
        .content-summary2 {
        //height: 100px;
        display: flex;
        justify-content: space-around;
        padding: 70px 0;
        //border: red solid 1px;
        .summary-left2 {
          width: 600px;
          //border: red solid 1px;
        }
      }

        .summary-right {
          //border: red solid 1px;
          width: 400px;
          height: 350px;
          border: 1px solid #1d42b9;
          //animation: imgboxkey 4s infinite;
          border-radius: 10px;
          margin-top: 80px;
          text-align: center;
          img{
            margin: 0 auto;
          }
        }
      }

      //发展历程
      .content-course {
        padding: 50px 0;
        .course-time {
          width: 1000px;
          height: 400px;
          margin: 20px auto;
          .swiper-container {
            height: 100%;
          }
          .time-show {
            width: 700px;
            height: 100%;
            margin: 0 auto;
            display: flex;
            .time-show-item {
              width: 350px;
              height: 100%;
              overflow: hidden;
              display: flex;
              flex-direction: column;

              .item-top,
              .item-bottom {
                height: 190px;
              }
              .item-bottom {
                // display: flex;
                // align-content: center;
                .item-bottom-content {
                  background-color: #1667a0;
                  margin: 20px 0;
                  p {
                    color: #fff;
                    text-align: center;
                    padding: 15px;
                  }
                }
              }
            }
          }
        }
      }

      //企业文化
      .content-culture {
        height: 450px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        padding-left: 100px;
        background-color: #c2daeb;
        h3 {
          color: #3c6088;
          font-size: 26px;
        }
        p {
          color: #3c6088;
          font-size: 26px;
          padding: 5px 0;
        }
        span {
          font-weight: 400;
          line-height: 36px;
          font-size: 18px;
          padding: 5px 0;
        }
      }

      //公司荣誉
      .content-honor {
        margin-top: 5%;
        padding: 50px 0;
        .honor-show {
          width: 1600px;
          margin: 30px auto;
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          align-content: flex-start;

          li {
            width: 220px;
            height: 320px;
            margin: 30px 35px 0 0;
            list-style: none;
            border: 1px solid palegoldenrod;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        p {
          text-align: center;
          color: #3c6088;
        }
      }

      //团队风采
      .content-team {
        padding: 50px 100px;
        .swiper-img {
          height: 400px;
          background: no-repeat center;
          background-size: cover;
        }
      }

      //合作伙伴
      .content-partner {
        padding: 50px 0;
        .partner-img {
          width: 950px;
          margin: 20px auto;
          display: flex;
          justify-content: flex-start;
          flex-wrap: wrap;
          li {
            width: 107px;
            height: 107px;
            list-style: none;
            margin: 10px 25px;

            img {
              width: 100%;
              height: 100%;
              border: 1px solid rgb(194, 218, 235);
            }
          }
        }
      }
    }
  }
}

@keyframes imgboxkey {
  0% {
    border: solid rgb(29, 66, 185) 2px;
  }
  40% {
    border: solid rgb(255, 255, 255) 2px;
  }
  60% {
    border: solid rgb(255, 255, 255) 2px;
  }
  100% {
    border: solid rgb(29, 66, 185) 2px;
  }
}

@keyframes imgbo {
  0% {
    transform: scale(1);
    box-shadow: 0px 0px 0px 0px #ababab;
  }
  50% {
    transform: scale(1.1);
    box-shadow: 0px 0px 10px 5px #ababab;
  }
  100% {
    transform: scale(1);
    box-shadow: 0px 0px 0px 0px #ababab;
  }
}
.el-divider--horizontal {
  margin: 1px 0;
}

.top {
  h3,
  p {
    text-align: center;
    color: #3c6088;
    font-weight: 400;
    padding: 10px 0;
  }
  h3 {
    font-size: 30px;
  }
  p {
    font-size: 20px;
  }
  .border {
    border-bottom: 1px solid #3c6088;
    width: 15%;
    margin: 0 auto;
    
  }
}
// .swiper-button-disabled {
//   display: none;
// }
.order {
  order: -1;
}
.order-top {
  order: 1;
}
.el-divider {
  
  background-color: red;
  height: 3px;
  .el-divider__text {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    padding: 0px;
    color: #fff;
    border: 3px solid red;
  }
}
.el-divider-active {
  background-color: #3c6088;
}
.honor-big-img {
  width: 100%;
  height: 100%;
  z-index: 10;
  text-align: center;
  //padding-bottom: 20px;
  //padding: 5%;
  //background-color: #14679f;
  .el-dialog__wrapper {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;

    .el-dialog__body {
      overflow: hidden;
      img {
        width: 100%;
      }
    }
  }
}
</style>